module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"questions":"questions | question | questions","minutes":"min","selected":"Selected"}}')
  delete Component.options._Ctor
}
